import styled from "styled-components";

export const SecurityContainer = styled.div`
  background: #ffffff;
  box-shadow: 2px 5px 10px #888888;
  border-radius: 5px;
  padding: 1rem;

  @media (max-width: 768px) {
  }
`;
export const MenuDiv = styled.div`
  display: flex;
  justify-content: space-between;
  /* background: #005319; */
  background: #128378;
  color: #ffffff;
  align-items: center;
  margin-bottom: 1rem;
  padding: 0.25rem 1rem;
  border-radius: 5px;
  @media (max-width: 768px) {
  }
`;
export const SubMenuDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;

  color: #128378;
  background: #ffffff;
  padding: 0.25rem 1rem;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const SubMenuPart = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #128378;
  padding: 0 1rem;
  @media (max-width: 768px) {
  }
`;

export const Line = styled.hr`
  margin-top: 1rem;
  color: #128378;
`;
export const Line1 = styled.hr`
  /* margin-top: 1rem; */
  color: #128378;
`;
